import React from 'react'
import { Link } from 'react-router'
import Header from '../../components/layout/header/Header'
import { Image } from 'react-bootstrap'
import ConfirmLens from '../../images/confirm-svg.svg'
const Lenconfirm = () => {
    return (
        <div className='userWrapper text-center'>
            <Header />
            <div className='confirm-lens d-flex align-items-center justify-content-center'>
              <div>
                <Image src={ConfirmLens} alt="lense" />
                  <h1 className='cpt-title text-center w100'>Congratulations! <br />
                    Your prescription has been confirmed</h1>
                <p className='presc-desc text-center w100'>
                    If you have any questions about this form, please email us at <br />
                    <Link className='hilight' rel="stylesheet" to="mailto:support@captify.glass">
                        support@captify.glass{" "}
                    </Link>
                </p>
              </div>
            </div>
        </div>
    )
}

export default Lenconfirm